// extracted by mini-css-extract-plugin
export default {"title":"about_title__SsLPg","about":"about_about__XBRFP"};